import React, { type Dispatch, type SetStateAction, useState } from "react";
import { SupInput } from "@repo/core-ui";
import { SupTxIcon } from "@repo/ui-widgets";
import { getAddress } from "viem";

import type { SupStoredTxSettings } from "@/types";
import { ADDRESS_REGEX } from "@/lib/constants";

interface Web3TxSettingsGroupRefundAddressProps {
  settings: SupStoredTxSettings;
  setSettings: Dispatch<SetStateAction<SupStoredTxSettings>>;
}

const validateInput = (value: string | undefined) => {
  if (!value) {
    return true;
  }

  return ADDRESS_REGEX.test(value);
};

export default function Web3TxSettingsGroupRefundAddress({ settings, setSettings }: Web3TxSettingsGroupRefundAddressProps) {
  const [contractAddress, setContractAddress] = useState<string | undefined>(settings.refundAddress);
  const [valid, setValid] = useState<boolean | undefined>();

  const handleChange = (value: string | undefined) => {
    const isValid = validateInput(value?.trim());
    if (isValid && value != settings.refundAddress) {
      const newSettings = {
        ...settings,
        refundAddress: value ? getAddress(value) : undefined,
      };

      setSettings(newSettings);
    }
    setContractAddress(value?.trim());
    setValid(isValid ? (value ? true : undefined) : false);
  };

  const renderIcon = (valid: boolean | undefined) => {
    switch (valid) {
      case true:
        return <SupTxIcon status="confirmed" />;
      case false:
        return <SupTxIcon status="reverted" />;
      default:
        return undefined;
    }
  };

  return (
    <div className="flex w-full flex-col items-start justify-stretch border-b-0.5 border-b-neutral-100 last-of-type:border-none">
      <SupInput
        inputProps={{
          className:
            "border-none bg-[transparent] enabled:focus:bg-[transparent] enabled:hover:bg-[transparent] max-w-[calc(100%-30px)] overflow-hidden normal-case placeholder:uppercase",
        }}
        clearable
        onChange={handleChange}
        prefixIcon={renderIcon(valid)}
        name="refund-address"
        placeholder="Please enter address"
        className="w-full"
        value={contractAddress}
      />
    </div>
  );
}
